import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import { FONTS } from '../constants/config';
import { Ionicons } from '@expo/vector-icons';

interface PendingDeletionBadgeProps {
  onPress?: () => void;
  compact?: boolean;
}

export default function PendingDeletionBadge({ onPress, compact = false }: PendingDeletionBadgeProps) {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  const content = (
    <View style={[styles.badge, compact && styles.compactBadge, isRTL && { flexDirection: 'row-reverse' }]}>
      <Ionicons name="time-outline" size={compact ? 12 : 14} color="#854D0E" />
      <Text style={[styles.text, compact && styles.compactText, isRTL && styles.rtlText]}>
        {t('deletion.pendingDeletion')}
      </Text>
    </View>
  );

  if (onPress) {
    return (
      <TouchableOpacity onPress={onPress}>
        {content}
      </TouchableOpacity>
    );
  }

  return content;
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: '#FEF9C3',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#FDE68A',
  },
  compactBadge: {
    paddingVertical: 2,
    paddingHorizontal: 6,
  },
  text: {
    fontSize: 11,
    color: '#854D0E',
    fontFamily: FONTS.medium,
  },
  compactText: {
    fontSize: 10,
  },
  rtlText: {
    textAlign: 'right',
  },
});
